import { useMemo } from 'react';
import { useGlobalSecurityReactContext } from 'framework/authorization';
import { HighlightUrlProvider } from 'framework/HighlightUrl';
import usePfrHighlightUrlService from 'domain/recruiting/positionFillRequests/usePfrHighlightUrlService';
import useFeatureToggle from 'framework/featureToggle';
import { Features } from 'infrastructure/featureToggle';

const HighlightUrlWrapper = ({ children }: { children: React.ReactNode }) => {
  const { permissions } = useGlobalSecurityReactContext();
  const pfrNotification = usePfrHighlightUrlService();

  const { isFeatureEnabled } = useFeatureToggle();

  const config = useMemo(
    () => [
      ...(isFeatureEnabled(Features.POSITION_FILL_REQUESTS_COLLECTION)
        ? [
            {
              ...pfrNotification,
            },
          ]
        : []),
    ],
    [isFeatureEnabled, pfrNotification],
  );

  return (
    <HighlightUrlProvider config={config} enabled={Boolean(permissions)}>
      {children}
    </HighlightUrlProvider>
  );
};

export default HighlightUrlWrapper;
